(() => {
  const selector = '.vst-header-search';

  function sync(form) {
    const input = form.querySelector('input[name="q"]');
    const clear = form.querySelector('.vst-header-search__clear');
    if (!input || !clear) return;
    form.dataset.searchEnhanced = '';
    clear.hidden = input.value.length === 0;
  }

  function initialize(root = document) {
    root.querySelectorAll(selector).forEach(sync);
  }

  function update(event) {
    const form = event.target.closest?.(selector);
    if (form) sync(form);
  }

  document.addEventListener('input', update);
  document.addEventListener('search', update);
  document.addEventListener('click', (event) => {
    const clear = event.target.closest?.('.vst-header-search__clear');
    const form = clear?.closest(selector);
    const input = form?.querySelector('input[name="q"]');
    if (!input) return;
    input.value = '';
    input.focus();
    input.dispatchEvent(new Event('input', { bubbles: true }));
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  window.addEventListener('pageshow', () => initialize());
  initialize();
})();
